import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full max-w-md transform rounded-lg border border-slate-200 bg-white shadow-xl transition-all duration-200" }
const _hoisted_2 = { class: "border-b border-slate-200 px-6 py-4" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = { class: "text-xl mb-0 font-bold text-slate-900" }
const _hoisted_5 = { class: "px-6 py-4" }
const _hoisted_6 = { class: "text-slate-600" }
const _hoisted_7 = { class: "flex justify-end gap-3 border-t border-slate-200 px-6 py-4" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "pi pi-spin pi-spinner"
}
const _hoisted_11 = {
  key: 1,
  class: "pi pi-trash"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 transition-opacity duration-200",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)), ["self"]))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex h-10 w-10 items-center justify-center rounded-full bg-red-100" }, [
                      _createElementVNode("i", { class: "pi pi-exclamation-triangle text-lg text-red-600" })
                    ], -1)),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.message), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
                    class: "inline-flex items-center justify-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-50 disabled:opacity-50 disabled:cursor-not-allowed",
                    disabled: _ctx.isLoading
                  }, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("span", null, "Huỷ", -1)
                  ]))], 8, _hoisted_8),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args))),
                    class: "inline-flex items-center justify-center gap-2 rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed",
                    disabled: _ctx.isLoading
                  }, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                      : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                    _createElementVNode("span", null, _toDisplayString(_ctx.isLoading ? "Đang xoá..." : "Xoá"), 1)
                  ], 8, _hoisted_9)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}